export default __webpack_public_path__ + "static/media/phoneAndHouse.f98fc96f.svg";